import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Ticker from "@/components/Ticker";
import ReminderBanner from "@/components/ReminderBanner";
import InstallBanner from "@/components/InstallBanner";
import Login from "@/pages/Login";
import Join from "@/pages/Join";
import Picks from "@/pages/Picks";
import Results from "@/pages/Results";
import Standings from "@/pages/Standings";
import Profile from "@/pages/Profile";
import HeadToHead from "@/pages/HeadToHead";
import News from "@/pages/News";
import Admin from "@/pages/Admin";
import { Loader2 } from "lucide-react";

function Shell({ children }) {
  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white">
      <Navbar />
      <Ticker />
      <ReminderBanner />
      <InstallBanner />
      {children}
    </div>
  );
}

function Protected({ children, adminOnly }) {
  const { user, ready } = useAuth();
  if (!ready || user === null)
    return (
      <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center text-white/50">
        <Loader2 className="w-6 h-6 animate-spin" />
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/standings" replace />;
  return <Shell>{children}</Shell>;
}

function LoginRoute() {
  const { user, ready } = useAuth();
  if (ready && user) return <Navigate to="/standings" replace />;
  return <Login />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginRoute />} />
            <Route path="/join/:code" element={<Join />} />
            <Route path="/picks" element={<Protected><Picks /></Protected>} />
            <Route path="/results" element={<Protected><Results /></Protected>} />
            <Route path="/standings" element={<Protected><Standings /></Protected>} />
            <Route path="/profile/:username" element={<Protected><Profile /></Protected>} />
            <Route path="/head-to-head" element={<Protected><HeadToHead /></Protected>} />
            <Route path="/news" element={<Protected><News /></Protected>} />
            <Route path="/admin" element={<Protected adminOnly><Admin /></Protected>} />
            <Route path="*" element={<Navigate to="/standings" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" theme="dark" />
      </AuthProvider>
    </div>
  );
}

export default App;
